import { print } from 'graphql'

import { logger } from '@app/common/logger/logger'
import { env } from '@app/env'
import { RefreshTokenLandingStatus } from '@app/graphql/types'
import {
  AcknowledgeRefreshTokenLandingDocument,
  AcknowledgeRefreshTokenLandingMutation,
  AcknowledgeRefreshTokenLandingMutationVariables
} from '@app/queries/AcknowledgeRefreshTokenLanding/AcknowledgeRefreshTokenLanding.queries'

const ACKNOWLEDGE_REFRESH_TOKEN_LANDING_MUTATION = print(AcknowledgeRefreshTokenLandingDocument)

type AcknowledgeRefreshTokenLandingParams = {
  token: string
  refreshTokenReceipt: string
  clientTabId: string
}

export const acknowledgeRefreshTokenLanding = async ({
  token,
  refreshTokenReceipt,
  clientTabId
}: AcknowledgeRefreshTokenLandingParams): Promise<
  RefreshTokenLandingStatus | 'ErrorAcknowledging'
> => {
  const variables: AcknowledgeRefreshTokenLandingMutationVariables = {
    refreshTokenReceipt,
    clientTabId
  }

  const response = await fetch(`${env.REACT_APP_SERVICE_MANAGER_PUBLIC_URL}/graphql`, {
    method: 'POST',
    keepalive: true,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ query: ACKNOWLEDGE_REFRESH_TOKEN_LANDING_MUTATION, variables })
  })

  const body = (await response.json()) as {
    data?: AcknowledgeRefreshTokenLandingMutation | null
    errors?: Array<{ message: string }>
  }

  if (body.errors?.length || !body.data) {
    logger.error(
      `Failed to acknowledge the refresh token landing: ${
        body.errors?.[0]?.message ?? 'no data returned'
      }`
    )

    return 'ErrorAcknowledging'
  }

  return body.data.acknowledgeRefreshTokenLanding
}
